var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-bet"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"time"},[_vm._v("\n\t\t"+_vm._s(_vm.time321)+"秒\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }